import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "state/hooks.ts";
import {
  getDepositFundsModalState,
  setPaymentMethodType
} from "state/slices/deposit-funds-modal-v2-slice.ts";
import { checkIfApplePayIsAvailable } from "services/apple-pay-service.ts";
import OrSeparator from "./or-separator.tsx";
import PaymentMethodTabs from "./payment-method-tabs.tsx";
import DepositFundsModalCardPaymentBlock from "./deposit-funds-modal-card-payment-block.tsx";
import DepositFundsModalAchPaymentBlock from "./deposit-funds-modal-ach-payment-block.tsx";
import ApplePayButton, { PaymentStatus } from "components/payment-provider/apple-pay/apple-pay-button.tsx";

const DepositFundsModalPaymentMethodsBlock = () => {
  const dispatch = useAppDispatch();
  const modalState = useAppSelector(getDepositFundsModalState);

  const [isApplePayAvailable, setIsApplePayAvailable] = useState(false);

  useEffect(() => {
    try {
      const applePayIsAvailable = checkIfApplePayIsAvailable();
      setIsApplePayAvailable(applePayIsAvailable);
    } catch (error) {
      console.error("Error checking Apple Pay availability: ", error);
      setIsApplePayAvailable(false);
    }
  }, []);

  const handleTabChange = (tab: 'CARD' | 'ACH') => {
    dispatch(setPaymentMethodType(tab));
  };

  return (
    <div style={{ padding: "8px 4px" }}>
      {/* Apple Pay Button */}
      {isApplePayAvailable && (
        <>
          <div className="d-flex justify-content-center mb-4">
            <ApplePayButton
              amount={modalState.selectedAmount}
              onPaymentAuthorized={() => {
                console.log('Apple Pay clicked');
                return Promise.resolve(PaymentStatus.SUCCESS);
              }}
            />
          </div>
          <OrSeparator />
        </>
      )}

      {/* Payment Method Tabs */}
      <PaymentMethodTabs
        activeTab={modalState.paymentMethodType}
        onTabChange={handleTabChange}
      />

      {/* Payment Method Details */}
      <div style={{
        marginTop: '20px',
        padding: '20px 0 0',
        borderTop: '1px solid rgba(255, 255, 255, 0.08)'
      }}>
        {modalState.paymentMethodType === 'CARD' ? (
          <DepositFundsModalCardPaymentBlock />
        ) : (
          <DepositFundsModalAchPaymentBlock />
        )}
      </div>
    </div>
  );
};

export default DepositFundsModalPaymentMethodsBlock; 